import { render, staticRenderFns } from "./MessageFromEmail.vue?vue&type=template&id=22d68939&scoped=true&"
import script from "./MessageFromEmail.vue?vue&type=script&lang=js&"
export * from "./MessageFromEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d68939",
  null
  
)

export default component.exports